<template>
    <div class="blackout" :class="{blocked: blocked, show: show}">
        <div class="modal">
            <div class="actions">
                <a href="#" class="close text-with-icon" @click.prevent="close">
                    <span>Close</span><img src="img/icons/s3/close_white.svg">
                </a>
            </div>
            <div v-if="component" class="content">
                <div class="inner" :class="{'component-fade' : componentFade}">
                    <component :is="component" v-bind="modalProps" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Modal',
        data() {
            return {
                show: false,
                blocked: false,
                timeout: null,
                component: null,
                componentFade: false
            };
        },
        computed: {
            modalComponent() {
                return this.$store.state.modal.modalComponent;
            },
            modalProps() {
                return this.$store.state.modal.modalProps;
            }
        },
        watch: {
            modalComponent() {
                if (this.component == null || this.modalComponent == null){
                    this.component = this.modalComponent;
                } else {
                    if(this.timeout) {
                        clearTimeout(this.timeout);
                        this.timeout = null;
                    }
                    this.componentFade = true;
                    this.timeout = setTimeout(() => {
                        this.componentFade = false;
                        this.component = this.modalComponent;
                    }, 500);
                }
            },
            component() {
                if (this.component == null && this.show == true || this.component != null && this.show == false ) {
                    this.toggleDisplay();
                }
            },
            show() {
                if (this.show == true){
                    document.body.classList.add('no-scroll'); 
                } else {
                    document.body.classList.remove('no-scroll'); 
                }
            }
        },
        methods: {
            toggleDisplay() {
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                if(this.modalComponent) {
                    this.show = false;
                    this.blocked = true;
                    this.timeout = setTimeout(() => {
                        this.show = true;
                    }, 10);
                } else {           
                    this.blocked = true;
                    this.show = false;
                    this.timeout = setTimeout(() => {
                        this.blocked = false;
                    }, 500);
                }
                
            },
            close() {
                this.$store.dispatch('closeModal');
            }
        }
    };
</script>

<style scoped>
    
    .blackout {background-color: rgba(0,0,0,.75); position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 999; opacity: 0; transition: .5s; display: none;}
    .blackout.show {opacity: 1;}
    .blackout.blocked {display: block;}
        .blackout > .spinner {position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto;}
        .blackout > .message {position: absolute; top: 30vh; right: 30vw; bottom: 30vh; left: 30vw; margin: auto; color:white;}
            .blackout > .message .error {color:orangered;}
            .blackout > .message a {color:#fff;}
            .blackout > .message .cta-link {margin-top: 2rem;}
    
    .modal {width: 90vw; height: 80vh; max-width: 50rem; max-height: 0rem; position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto; overflow: hidden; transition: .25s;}
    .show .modal {max-height: 35rem;}
        .modal > .actions {height: 2rem; text-align: right;}
            .modal > .actions .close {color: #fff; text-transform: uppercase;}
        .modal > .content {padding: 2.5rem; height: calc(100% - 2rem); overflow-y: auto; box-sizing: border-box; background: #F0EEEE;}
        .modal > .content > .inner {opacity: 1; transition: .5s;}
        .modal > .content > .inner.component-fade {opacity: 0; transition: .5s;}
    
</style>